import React from 'react';
import { PulseCheckWrapper } from '../PulseCheck.wrapper';
import { Workflow } from './Workflow';

interface Props {
  clientId: string;
}

export default (props: Props) => {
  return (
    <PulseCheckWrapper>
      <Workflow {...props} />
    </PulseCheckWrapper>
  );
};
